// const api = "http://ec2-13-126-112-36.ap-south-1.compute.amazonaws.com:8080/";
// const api = "http://192.168.29.120:8080/";
const api = process.env.REACT_APP_API_URL;
export default api;
